module.exports = __webpack_public_path__ + "img/confirm-title.75aa50eb.png";